import splide, { customSplide } from "../utils/splide";

const banner = document.getElementById("banner");
if (banner) {
    const bannerSplide = customSplide(banner, {
        type: "fade",
        rewind: true,
        perPage: 1,
        autoplay: true,
        fixedHeight: "560px",
        speed: 2000,
        lazyLoad: "sequential",
        pagination: false,
        arrows: true,
        breakpoints: {
            1200: {
                pagination: false,
                arrows: false,
                fixedHeight: "unset",
            },
            600: {
                fixedHeight: "unset",
                arrows: false,
                pagination: false,
            },
        },
    });
    bannerSplide.mount();
}

function initanimanumeros() {
    const titles = document.querySelectorAll(".bannercards__card-title");
    if (!titles.length) return;

    const duration = 2000;
    const animations = [];

    titles.forEach((el) => {
        const text = el.textContent;
        const numbers = text.match(/\d+/g);
        if (!numbers) return;

        let offset = 0;
        const numberData = numbers.map((numStr) => {
            const pos = text.indexOf(numStr, offset);
            offset = pos + numStr.length;
            return {
                final: parseInt(numStr, 10),
                current: 0,
                len: numStr.length,
                pos: pos,
            };
        });

        animations.push({ element: el, text: text, numbers: numberData });
    });

    if (!animations.length) return;

    const updateText = (anim) => {
        let result = anim.text;
        let offset = 0;
        anim.numbers
            .sort((a, b) => a.pos - b.pos)
            .forEach((data) => {
                const val = Math.floor(data.current).toString().padStart(data.len, "0");
                const pos = data.pos + offset;
                result = result.substring(0, pos) + val + result.substring(pos + data.len);
                offset += val.length - data.len;
            });
        anim.element.textContent = result;
    };

    animations.forEach((anim) => {
        anim.numbers.forEach((n) => (n.current = 0));
        updateText(anim);
    });

    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const startTime = Date.now();

    const animate = () => {
        const progress = easeOut(Math.min((Date.now() - startTime) / duration, 1));
        animations.forEach((anim) => {
            anim.numbers.forEach((n) => (n.current = n.final * progress));
            updateText(anim);
        });
        if (progress < 1) requestAnimationFrame(animate);
        else animations.forEach((anim) => {
            anim.numbers.forEach((n) => (n.current = n.final));
            updateText(anim);
        });
    };

    const start = () => setTimeout(() => requestAnimationFrame(animate), 100);
    document.readyState === "loading" ? document.addEventListener("DOMContentLoaded", start) : start();
}

initanimanumeros();


const services = document.getElementById("services");
if (services) {
    const servicesSplide = customSplide(services, {
        type: "slide",
        rewind: true,
        perPage: 4,
        autoplay: true,
        speed: 2000,
        gap: "20px",
        lazyLoad: "sequential",
        pagination: false,
        arrows: false,
        breakpoints: {
            1200: {
                perPage: 3,
                pagination: false,
                fixedHeight: "unset",
            },
            900: {
                perPage: 2,
                pagination: false,
                fixedHeight: "unset",
            },
            600: {
                perPage: 1,
                pagination: true,
                arrows: false,
                fixedHeight: false,
            },
        },
    });
    servicesSplide.mount();
}

const partners = document.getElementById("partners");
if (partners) {
    const partnersSplide = customSplide(partners, {
        type: "slide",
        rewind: true,
        perPage: 4,
        autoplay: true,
        speed: 2000,
        gap: "25px",
        lazyLoad: "sequential",
        pagination: false,
        arrows: false,
        breakpoints: {
            1200: {
                perPage: 3,
                pagination: false,
                fixedHeight: "unset",
            },
            900: {
                perPage: 2,
                pagination: false,
                fixedHeight: "unset",
            },
            600: {
                perPage: 1,
                pagination: true,
                fixedHeight: false,
            },
        },
    });
    partnersSplide.mount();
}

const testimonies = document.getElementById("testimonies");
if (testimonies) {
    const testimoniesSplide = customSplide(testimonies, {
        type: "slide",
        rewind: true,
        perPage: 3,
        autoplay: true,
        speed: 2000,
        gap: "25px",
        lazyLoad: "sequential",
        pagination: false,
        arrows: true,
        breakpoints: {
            1200: {
                perPage: 3,
                pagination: false,
                fixedHeight: "unset",
            },
            900: {
                perPage: 2,
                pagination: false,
                fixedHeight: "unset",
            },
            600: {
                perPage: 1,
                pagination: true,
                arrows: false,
                fixedHeight: false,
            },
        },
    });
    testimoniesSplide.mount();
}